<template>
	<div class="row">
		<div class="col-12" v-if="!model_id_local">
			<h2>{{ $t("courrier_type.generation") }}</h2>
			<div>
				<label for="model_type">{{ $t('courrier_type.placeholder_type') }}</label>
				<e-select
		            v-model="model_selected"
		            id="models"
		            track-by="model_id"
		            label="model_label"
		            class="primary"
		            :options="models"
		            :searchable="true"
		            :show-labels="false"
		            :allow-empty="false"
					:placeholder="$t('courrier_type.placeholder_type')"
		        >
		            <template slot="singleLabel" slot-scope="{ option }">{{ option.model_label }}</template>
		            <template slot="noOptions">{{ $t('global.list_empty') }}</template>
		        </e-select>
		    </div>

	        <div class="mt-3">
	    		<label>{{ $t('courrier_type.model_label') }}</label>
				<input type="text" class="form-control" :placeholder="$t('courrier_type.model_label')" v-model="model_label">
			</div>

			<div class="mt-3">
				<label>{{ $t('courrier_type.model_contact') }}</label>
				<e-select
					v-model="contact"
					id="contact_id"
					track-by="contact_id"
					label="contact_label"
					:placeholder="$t('acte.selectionnez_contact')"
					:selectedLabel="$t('global.selected_label')"
					:options="all_contacts"
					:searchable="true"
					:allow-empty="true"
					:loading="isLoadingContact"
					:show-labels="false"
					:group-select="false"
				/>
			</div>

	        <div v-if="model_selected" class="text-center">
	            <b-button pill variant="primary" class="mt-3" @click.prevent="addModel"><font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /> {{ $t("courrier_type.generer") }}</b-button>
	        </div>
	    </div>
	    <div v-else class="col">
			<div class="ml-4 mr-4" v-if="contact">
	    		<label>{{ $t('courrier_type.model_contact') }}</label>
				<input type="text" class="form-control" :placeholder="$t('courrier_type.model_label')" v-model="contact.contact_label" disabled="true">
			</div>
	    	<Edit ref="edit" :modelable_id="horse_id" :modelable_type="model_type_generated" :model_id="model_id_local" class_perso="_" :preview_pdf.sync="preview_pdf" :save_pdf="false"/>
	    </div>
	    <div v-if="base64" class="col-6">
			<iframe v-if="base64 != null" :src="'data:application/pdf;base64,' + base64" height="1000px" width="100%" style="position:relative"></iframe>
	    </div>
	</div>
</template>

<script type="text/javascript">
	import Common from '@/assets/js/common'
	import Contact from '@/mixins/Contact.js'
    import ModelMixin from "@/mixins/Model.js";
	import Shutter from '@/mixins/Shutter.js'
	import Tiers from '@/mixins/Tiers.js'

	export default {
		name: 'HorseEdit',
		mixins: [Contact, ModelMixin, Shutter, Tiers],
		props: ['model_id', 'horse_id', 'modeltype_template', 'model_contact'],
		data () {
			return {
				models: [],
				model_label: "",
				model_selected: null,
				processing: null,
				model_id_local: null,
				modeltype_template_local: null,
				base64: null,
				preview_pdf: true,
				contact: null,
				isLoadingContact: true,
				all_contacts: [],
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				if(!this.model_id) {
					this.models = await this.loadAllModel(0, ['horse_envoie_infos'])
					this.isLoadingContact = true

					let tiers_horse = await this.loadHorseTiers(this.horse_id)
					let tiers_horse_secondaires = await this.loadTiersHorseSecondaires(this.horse_id)
					tiers_horse_secondaires = tiers_horse_secondaires.map(ths => ({
						tiers_id: ths.tiers.tiers_id,
						tiers_rs: ths.tiers.tiers_rs
					}))
					tiers_horse = tiers_horse.concat(tiers_horse_secondaires)

					let contacts = [];
					await Common.asyncForEach(tiers_horse, async (th) => {
						const contacts_tiers = await this.getContactByTiers(th.tiers_id)
						contacts_tiers.forEach(ct => {
							ct.tiers_rs = th.tiers_rs
							contacts.push(ct)
						})
					})

					this.all_contacts = contacts.filter(contact => {
						return contact.contact.contact_mail !== ''
					})
					.map(contact => ({
						contact_id: contact.contact.contact_id,
						contact_label: contact.tiers_rs + ' / ' + contact.contact.contact_firstname + ' ' + contact.contact.contact_lastname
					}))

					this.isLoadingContact = false
				} else {
					this.model_id_local = this.model_id
					this.modeltype_template_local = this.modeltype_template
					if(this.model_contact) {
						this.contact = await this.getContactById(this.model_contact)
					}
				}
			},

			async addModel() {
				this.processing = true
				if(this.model_label !== "") {
					const contact_id = this.contact ? this.contact.contact_id : null
					const model = await this.createModel(this.horse_id, this.model_selected.type.modeltype_id, this.model_label, this.model_selected.type.modeltype_template, contact_id)
					await this.cloneModel(this.model_selected.model_id, model.model_id)
					await this.generateCourrier(model.model_id, this.model_selected.type.modeltype_template, this.horse_id)
					this.modeltype_template_local = this.model_selected.type.modeltype_template
					this.model_id_local = model.model_id
					this.processing = false
					this.shutterPanel().reload('courrier-type')
				}
				else {
					this.failureToast('toast.no_model_label')
					this.processing = false
				}
			},

			async previewCourrier() {
				await this.$refs.edit.saveForm()
				this.base64 = await this.printCourrier(this.model_id_local, '', true)
			}
		},

		computed: {
			model_type_generated() {
				if(this.modeltype_template_local == 'horse_envoie_infos')
					return 'horse_envoie_infos_generated'
				return this.modeltype_template_local
			}
		},

		watch: {
			preview_pdf(val) {
				this.previewCourrier()
			}
		},

		components: {
			Edit : () => import('@/components/Model/Edit')
		}
	}

</script>